import React, { useState, useEffect } from "react";
//import PlayerProps from './PlayerProps';
import PlayerState, { StackType } from "./PlayerState";
import { Scrim } from '@att-bit/duc.fragments.scrim';
//import "./Player.css";
import { Controller } from "@att-bit/gvp.atoms.controller";
import {
  VideoComponent,
  VideoComponentOptions,
} from "@att-bit/gvp.atoms.video-component";
//import { VideoComponentOptions } from '../VideoComponent/VideoComponentProps';
import { TranscriptComponent } from "@att-bit/gvp.atoms.transcript-component";
//import { Ratings } from "@att-bit/gvp.atoms.ratings";
/* Replacing the old Ratings with Ratings-v2 */
import { Ratings } from "@att-bit/gvp.atoms.ratings-v2";
import { IconSvg, IconSvgSizes } from "@att-bit/duc.components.icon-svg";
import { closeIcon } from "./Constants";
//import { VideoComponentOptions } from "@att-bit/gvp.atoms.video-component/_src/video-component";
import { useRef } from "react";

export type PlayerProps = {
  /**
   *  ref for the Video
   */
  ref?: any;
  /**
   *  Data for Ratings
   */
  data: PlayersData;
  /**
   *  Events for the Ratings
   */
  events?: PlayerEvents;
  /**
   *  Additional options for Ratings to enable different interfaces like Model etc.
   */
  options?: PlayerOptions;
  /**
   *  Additional id passed to Ratings
   */
  testId?: string;
};
export type PlayersData = {
  //type: string;

  id: string;
  poster: string;
  recommendedVideosCTAViewData: any;
  sources: string[];
  textTracks: any[];
  chapteredVideo: [];
  title: string;
  linkUrl: string[];
  date: string;
  duration: string;
  printTitle: string;
};

export type PlayerOptions = {
  hidden?: boolean;
  modal?: boolean;
  cinema?: boolean;
  videoStyles?: string;
  rating?: string;
  showCaption?: boolean;
  autoplay?: boolean;
  loop?: boolean;
  safariAutoPlay?: boolean;
  containerWidth?: any;
  playerView?: boolean;
  roundedCornersClassName?: string;
  unconstrained?: boolean;
};

export type PlayerEvents = {
  submitted?(submitted: boolean, rating: number, feedback: string): any;
  handlePlayPause(play: boolean);
  playRecommendedVideoItem(mediaId: string);
  close();
  handleVideoCommence();
  handleSafariAutoPlay?(): void;
};

export class Player extends React.Component<PlayerProps, PlayerState> {
  state: PlayerState;
  ref: any;
  videoRef: any;
  ariaLiveText = '';
  private controllerRef: any;
  private controlsOpacity: number = 1;
  private controlsDelayToFade: number = 3000;
  private isTouchDevice = false;
  private touchStart = false;
  private durationCalculated = false;
  private forceModal = false;

  constructor(props: PlayerProps) {
    super(props);
    this.state = new PlayerState();
    this.state.showCaption = false;
    this.ref = React.createRef();
    this.videoRef = React.createRef();
    this.controllerRef = React.createRef();
    this.isTouchDevice = !!('ontouchstart' in window) || !!navigator.maxTouchPoints;
    this.handlePlayPause = this.handlePlayPause.bind(this);
    this.captionClick = this.captionClick?.bind(this);
    this.fullScreenClick = this.fullScreenClick?.bind(this);
    this.transcriptClick = this.transcriptClick.bind(this);
    this.handleVolume = this.handleVolume.bind(this);
    this.getDuration = this.getDuration.bind(this);
    this.handleSeekVideo = this.handleSeekVideo.bind(this);
    this.handleFullScreenChange = this.handleFullScreenChange.bind(this);
    this.updateCurrentTime = this.updateCurrentTime.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.playRecommendedVideoItem = this.playRecommendedVideoItem.bind(this);
    this.updatePlaying = this.updatePlaying.bind(this);
    this.handleTranscriptUpdateTime = this.handleTranscriptUpdateTime.bind(this);
    this.userFocusedHandler = this.userFocusedHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.handleRatings = this.handleRatings.bind(this);
    this.handleFocusWithinModal = this.handleFocusWithinModal.bind(this);
  }

  componentDidMount() {
    let playerContainerClassName = '';
      if(this.props.options.containerWidth  >= 1500 ){
        playerContainerClassName = 'Player__player__GT1500';
      } else if(this.props.options.containerWidth  > 800 ){
        playerContainerClassName = 'Player__player__GT800';
      }else if(this.props.options.containerWidth  > 500 && this.props.options.containerWidth  <= 800 ){
        playerContainerClassName = 'Player__player__GT500__LT800';
      }else if(this.props.options.containerWidth  > 250 && this.props.options.containerWidth  <= 500  ){
        playerContainerClassName = 'Player__player__GT250__LT500';
      }else if(this.props.options.containerWidth  <= 250 ){
        playerContainerClassName = 'Player__player__LT250';
      }
      this.setState({playerContainerClassName: playerContainerClassName});
    document.addEventListener<'fullscreenchange'>(
      'fullscreenchange',
      this.handleFullScreenChange,
    );
    if (this.props?.options?.modal) {
      // @ts-ignore: TODO
      window.addEventListener('keydown', this.handleFocusWithinModal);
    }
    if(this.props?.options?.playerView) {
      this.props.events?.handleSafariAutoPlay();
      this.props.events.handleVideoCommence();
    }
    // document.addEventListener<'webkitfullscreenchange'>('webkitfullscreenchange', this.handleFullScreenChange);
  }

  componentWillUnmount() {
    document.removeEventListener<'fullscreenchange'>(
      'fullscreenchange',
      this.handleFullScreenChange,
    );
  }

  handleFocusWithinModal(e: {
    keyCode: number;
    shiftKey: any;
    target: HTMLButtonElement;
    preventDefault: () => void;
  }) {
    if (e.keyCode === 9 && this.props?.options?.modal) {
      const focusable = document.querySelector('#modal')
        ? document.querySelector('#modal')?.querySelectorAll('button')
        : null;
      if (focusable && focusable.length) {
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const shift = e.shiftKey;
        if (shift) {
          if (e.target === first) {
            last.focus();
            e.preventDefault();
          }
        } else if (e.target.nodeName === 'BODY') {
          first.focus();
        } else {
          if (e.target === last) {
            first.focus();
            e.preventDefault();
          }
        }
      }
    }
  }

  handleFullScreenChange(e: any) {
    if (!e.currentTarget.fullscreen) {
      this.setState({ fullscreen: e.currentTarget.fullscreen });
    }
  }
  handlePlayPause(play: boolean) {
    this.setState({ playing: play });
  }
  captionClick?(showing: boolean) {
    this.setState({ showCaption: showing });
  }
  fullScreenClick?(input: boolean) {
    if (!this.ref.current) {
      return;
    }
    if (input) {
      if (this.ref.current.requestFullscreen) {
        this.ref.current.requestFullscreen(); // IE
      } else if (this.ref.current.msRequestFullscreen) {
        this.ref.current.msRequestFullscreen(); // IE 11
      } else if (this.ref.current.mozRequestFullScreen) {
        this.ref.current.mozRequestFullScreen(); // Firefox
      } else if (this.ref.current.webkitRequestFullscreen) {
        this.ref.current.webkitRequestFullscreen(); // Chrome and Safari
      } else {
        this.forceModal = true;
      }
    } else {
      if (this.forceModal) {
        this.forceModal = false;
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
        // } else if (document.msExitFullscreen) {
        //     document.msExitFullscreen();
        // } else if (document.mozCancelFullScreen) {
        //     document.mozCancelFullScreen();
        // } else if (document.webkitCancelFullScreen) {
        //     document.webkitCancelFullScreen();
      }
      if (this.props.options && this.props.options.cinema) {
        setTimeout(() => {
          this.ref.current.scrollIntoView(true, { behavior: 'smooth' });
        }, 100);
      }
    }
    this.setState({ fullscreen: input });
  }
  transcriptClick(value: boolean) {
    this.setState({ showTranscript: value });
  }
  handleVolume(m: boolean, vol: number) {
    this.setState({ mute: m, volume: vol });
  }
  handleSeekVideo(val: number) {
    this.setState({ currentTime: val, ctrlCurrentTime: val });
  }
  getDuration(duration: number, playIndex?: number) {
    let totTime = duration;
    if (this.props.data.chapteredVideo && this.props.data.chapteredVideo.length) {
      this.props.data.chapteredVideo.forEach(
        (element: { seconds: number }, i: number | undefined) => {
          if (i !== playIndex) {
            totTime = totTime + element.seconds;
          }
        },
      );
    }
    this.setState({ totalTime: totTime });
  }
  updatePlaying(val: boolean) {
    this.setState({ playing: val });
    if (this.props.events && this.props.events.handlePlayPause) {
      this.props.events.handlePlayPause(val);
    }
  }
  updateCurrentTime(val: number, ended: boolean) {
    if (ended) {
      this.setState({ ctrlCurrentTime: val, playing: !ended });
    } else {
      this.setState({ ctrlCurrentTime: val });
    }
  }

  handleContainerClick(event: React.MouseEvent<HTMLElement>) {
    // closes modal when click on background only
    this.userFocusedHandler();
    if (!this.props?.options?.modal) {
      return;
    }
    if (event.target === this.ref.current) {
      // this.close();
    }
  }
  handleClose() {
    if (this.props.events && this.props.events.close) {
      this.props.events.close();
    }
  }

  playRecommendedVideoItem(mediaId: string) {
    this.props?.events?.playRecommendedVideoItem(mediaId);
  }

  render() {
    const isModal = this.props.options && this.props.options.modal;
    const isCinema = this.props.options && this.props.options.cinema;
    const unconstrainedClassName = this.props?.options?.unconstrained === true && !isModal ? ' unconstrained': '';
    let stylesObj: any = {};
    if (this.props.options && this.props.options.videoStyles && isCinema) {
      stylesObj = JSON.parse(this.props.options.videoStyles);
    }
    const containerClass =
      "Player__view" + this.props?.options?.roundedCornersClassName + ' ' + (isModal ? ' ' : "Player__bg") + ' ' +
      (isModal ? ' ' + "Player__modal flex-items-center justify-center " : '') +
      (this.state.fullscreen ? ' ' + "Player__fullscreen" : '') +
      (isCinema ? ' ' + "Player__cinema" : '');
    const rating = this.props.options && this.props.options.rating;
    const showRating =
      rating &&
      !this.state.ratingSubmitted &&
      !isCinema &&
      this.state.ctrlCurrentTime > 5;
    const playerObject = <div
    id={isModal ? 'modal' : 'cinema'}
    className={containerClass}
    ref={this.ref}
    onMouseEnter={this.userFocusedHandler}
    onMouseMove={this.userFocusedHandler}
    onMouseLeave={this.userFocusedHandler}
    onFocus={this.userFocusedHandler}
    onTouchStart={this.userFocusedHandler}
    onTouchMove={this.userFocusedHandler}
    onClick={this.clickHandler}
    style={stylesObj}
  >
    {!isModal && !this.props.options.playerView && this.getCloseButton(isModal!, isCinema!)}

    <div
      aria-live={'polite'}
      style={{ position: 'absolute', visibility: 'hidden' }}
    >
      {this.ariaLiveText}
    </div>
    <div
      className={
        "Player__player" + this.props?.options?.roundedCornersClassName + ' ' +  this.state.playerContainerClassName + ' ' +
        (isModal ? ' ' + "Player__modal" : '') +
        (this.state.fullscreen ? ' ' + "Player__fullscreen" : '') +
        (isCinema ? ' ' + "Player__cinema" : '') +
        unconstrainedClassName
      }
    >
      {isModal && !this.props.options.playerView && this.getCloseButton(isModal, isCinema!)}

      <div
        className={
          "Player__viewport" + this.props?.options?.roundedCornersClassName + ' ' +
          (this.state.fullscreen ? ' ' + "Player__fullscreen" : '') +
          (isModal ? ' ' + "Player__modal" : '') +
          (isCinema ? ' ' + "Player__cinema" : '') +
          unconstrainedClassName + (this.props?.options?.unconstrained === true && !isModal ? '' : ' Player__player__viewport')
        }
      >
        <div className={"Player__title font-regular color-att-blue"}>
          {this.props.data && this.props.data.title}
        </div>

        {this.getVideoComponent()}

        {this.small && !isCinema ? this.getTranscript() : null}

        {!isCinema && this.getControls()}

        {showRating && this.getRatingPanel()}
      </div>
      {isCinema && this.getControls()}
      {this.small && !isCinema ? null : this.getTranscript()}
    </div>
  </div>;
    return (
      <>
      {/*
              // @ts-ignore */}
              <style jsx global>{`
              .Player__view {
                display: -ms-flexbox;
                display: flex;
                -ms-justify-content: center;
                -ms-flex-pack: center;
                justify-content: center;
                padding: 10px;
                width: 100%;
                height: 100%;
                flex: 1 1 auto;
                -ms-flex: 1 1 auto;
                box-sizing: border-box;
                position: relative; }

              .Player__bg {
                background: #191919;
              }

              .Player__view.Player__modal {
                height: 100%;
                width: 100%; }
                .Player__view.Player__modal button:focus {
                  outline: 1px dotted;
                  outline-color: inherit; }
              
              .Player__view.Player__cinema {
                padding: 0; }
              
              .Player__player {
                display: flex;
                -ms-justify-content: center;
                -ms-flex-pack: center;
                justify-content: center;
                min-height: 0;
                max-width: 100%;
                min-height: 0;
                max-height: 100%;
                height: 100%;
                -ms-flex: 0 1 auto;
                flex: 0 1 auto;
                position: relative;
                box-sizing: border-box;
                }
              
              .Player__player.Player__fullscreen {
                padding: 0;
                width: 100%; }
              
              .Player__player.Player__modal {
                max-height: 600px;
                background-color: #191919;
                padding: 10px;
                }
              
              .Player__player.Player__modal.Player__fullscreen {
                max-height: none; }
              
              .Player__player.Player__cinema {
                width: 100%;
                max-height: none;
                background: #000;
                padding: 0; }
              
              .Player__top {
                flex: 1 1 auto;
                width: 100%;
                position: relative; }
              
              .Player__player__viewport {
                max-width: 854px;
                width: 854px;
              }
              .Player__viewport {
                display: flex;
                -ms-flex-direction: column;
                flex-direction: column;
                justify-content: center;
                -ms-flex: 1 1 auto;
                flex: 1 1 auto;
                min-height: 0;
                max-height: 100%;
                min-width: 0;
                position: relative;
                height: 100%;
                align-items: stretch;
                }
              
              .Player__viewport.Player__fullscreen {
                width: 100%;
                max-width: 100%; }
              
              .Player__viewport.Player__modal {
                max-width: none; }
              
              .Player__viewport.Player__cinema .Player__title {
                display: none; }
              
              .Player__title {
                font-size: 1.6em;
                line-height: 1em;
                flex: 0 0 auto;
                -ms-flex: 0 0 auto;
                text-align: left;
                padding: 10px 0 20px 0; }
              
              .Player__closeButton {
                position: absolute;
                top: 8px;
                right: 8px;
                z-index: 1;
                margin: 8px;
                }
              .Player__closeButton:focus {
                outline-style: dotted;
                outline-width: 3px;
                outline-color: #fff;
              }
              .Player__closeButton.Player__modal {
                top: 0;
                right: 0; }
              
              .Player__closeButton.Player__cinema {
                top: 0;
                right: 0; }
              
              .Player__player__video {
                max-width: 854px;
              }
              .Player__video {
                -ms-flex: 1 1 auto;
                flex: 1 1 auto;
                position: relative;
                min-height: 0;
                max-height: 100%;
                width: 100%;
              }
              
              .Player__video.Player__modal {
                -ms-flex: 0 1 auto;
                flex: 0 1 auto; }
              
              .Player__video.Player__fullscreen {
                width: 100%;
                max-width: 100%; }
              
              .Player__video.Player__cinema {
                width: 100%;
                max-width: 100%; }
              
              .Player__videoPlayButton {
                width: 100px;
                height: 100px;
                max-width: none;
                max-height: none;
                position: relative;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                fill: white; }
              
              .Player__videoOverlay {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0; }
              
              .Player__videoLoaderButton {
                width: 100px;
                height: 100px;
                fill: #fff;
                -webkit-animation: Player__fadeinout 1s linear 1 forwards;
                animation: Player__fadein 1s linear 1 forwards;
                position: relative;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%); }
              
              .Player__controller.Player__cinema {
                position: absolute;
                top: 100%;
                left: 0;
                transform: translateY(-100%);
                background: rgba(0, 0, 0, 0.75);
                transition: opacity 0.75s;
                padding: 0; }
              
              /* end screen */
              .Player__endScreen {
                /*position: absolute;
                  width: 100%;
                  height: 100%;*/
                position: relative;
                top: 50%;
                transform: translate(0, -50%);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;
                color: #fff;
                opacity: 0.8;
                font-size: 1.2em; }
              
              .Player__endScreenSection {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 5px;
                margin-right: 5px;
                background-color: rgba(0, 0, 0, 0.8);
                padding: 7px;
                padding-left: 14px;
                padding-right: 14px;
                margin: 7px;
                border-radius: 5px;
                border-style: none;
                white-space: nowrap;
                min-height: 50px; }
              
              .Player__endScreenIcon {
                width: 50px;
                height: 50px;
                background-color: transparent;
                fill: #f1f1f1; }
              
              .Player__ControllerOpacity {
                opacity: 0 !important; }

                  .Player__player__GT800 .Player__viewport .Player__panel {
                    min-width: 276px;
                    max-width: 276px;
                    margin-top: 3.5em;
                    margin-left: 10px; }
                 .Player__player__GT800 .Player__viewport .Player__panel .Player__fullscreen {
                      margin-top: 0 !important; }
  
                 .Player__player__GT500__LT800 .Player__viewport .Player__title {
                    font-size: 1.2em; }
                  
                  .Player__player__GT500__LT800 .Player__viewport .Player__closeButton {
                    margin: 0; }
                  
                  .Player__player__GT500__LT800 .Player__viewport .Player__panel {
                    max-width: 276px;
                    min-width: 180px;
                    margin-left: 10px;
                    margin-top: 3em; }
                  .Player__player__GT500__LT800 .Player__viewport .Player__panel .Player__fullscreen {
                      margin-top: 0 !important; }
                  .Player__player__GT500__LT800 .Player__viewport .Player__panel .Player__modal {
                      max-height: 446px; }
  
                 .Player__player__GT250__LT500 .Player__viewport .Player__title {
                    font-size: 1em; }
                  
                 .Player__player__GT250__LT500 .Player__viewport .Player__closeButton {
                    margin: 0; }
                  
                .Player__player__GT250__LT500 .Player__viewport .Player__panel {
                    flex: 1 1 auto;
                    min-width: 100%;
                    max-width: 100%;
                    min-height: 0;
                    max-height: 240px;
                    height: 240px;
                    margin-left: 0;
                    margin-right: 0;
                    margin-top: 0px; }


              @media screen and (min-width: 800px) {
                .Player__viewport .Player__panel {
                  min-width: 276px;
                  max-width: 276px;
                  margin-top: 3.5em;
                  margin-left: 10px; }
                .Player__viewport .Player__panel .Player__fullscreen {
                    margin-top: 0 !important; }
              }

              @media screen and (min-width: 500px) and (max-width: 800px) {
                .Player__viewport .Player__title {
                  font-size: 1.2em; }
                
                .Player__viewport .Player__closeButton {
                  margin: 0; }
                
                .Player__viewport .Player__panel {
                  max-width: 276px;
                  min-width: 180px;
                  margin-left: 10px;
                  margin-top: 3em; }
                  .Player__viewport .Player__panel .Player__fullscreen {
                    margin-top: 0 !important; }
                  .Player__viewport .Player__panel .Player__modal {
                    max-height: 446px; }
              }

              @media screen and (min-width: 251px) and (max-width: 500px) {
                .Player__viewport .Player__title {
                  font-size: 1em; }
                
                .Player__viewport .Player__closeButton {
                  margin: 0; }
                
                .Player__viewport .Player__panel {
                  flex: 1 1 auto;
                  min-width: 100%;
                  max-width: 100%;
                  min-height: 0;
                  max-height: 240px;
                  height: 240px;
                  margin-left: 0;
                  margin-right: 0;
                  margin-top: 0px; }
              }
              
              // @media screen and (min-width: 250px) {
              //   .Player__viewport .Player__title {
              //     display: none; }
                
              //   .Player__viewport .Player__controller {
              //     display: none; }
                
              //   .Player__viewport .Player__panel {
              //     display: none; }    
              // }          
              `}</style>
       { isModal ? <Scrim show={true}>
              {playerObject}
      </Scrim> :  playerObject }
      </>
    );
  }

  private getRatingPanel() {
    return (
      <Ratings
        data={{ type: this.props?.options?.rating || '' }}
        events={{ submitted: this.handleRatings }}
      />
    );
  }

  private handleRatings(submitted: boolean, rating: number, feedback: string) {
    console.log('rating::', rating, 'feedback::', feedback);
    this.setState({ ratingSubmitted: submitted });
  }

  private clickHandler(event: any) {
    this.userFocusedHandler(event);
    if (!this.props.options?.modal) {
      return;
    }
    if (event.target === this.ref.current) {
      this.handleClose();
    }
  }
  private userFocusedHandler(event?: any) {
    if (!this.props?.options?.cinema) {
      return;
    }
    const controllerElement =
      event && event.currentTarget &&
      event.currentTarget.getElementsByClassName("Player__controller")[0];
    if ((this as any).___localMouseMoveTimeout) {
      clearTimeout((this as any).___localMouseMoveTimeout);
    }
    if (!this.controlsOpacity && 'undefined' !== typeof controllerElement) {
      this.controlsOpacity = 1;
      controllerElement.style.opacity = 1;
    }
    (this as any).___localMouseMoveTimeout = setTimeout(
      () => {
        if (!this.state.playing) {
          return;
        }
        if ('undefined' !== typeof controllerElement) {
          this.controlsOpacity = 0;
          controllerElement.style.opacity = 0;
        }
      },
      event && event.type.toLowerCase() === 'mouseout'
        ? 0
        : this.controlsDelayToFade,
    );
  }

  private getCloseButton(isModal: boolean, isCinema: boolean) {
    return (
      <button
        id="closeVideo"
        onClick={this.handleClose}
        className={
          "Player__closeButton round icon-close height-md-all width-md-all bg-white" +
          (isModal ? ' ' + "Player__modal" : '') +
          (isCinema ? ' ' + "Player__cinema" : '') +
          ' '
          // + (this.isTouchDevice || !isCinema ? ' ' + "Player__large : '')
        }
        style={{
          display: this.state.fullscreen ? 'none' : '',
          opacity: this.controlsOpacity,
        }}
        title="Close Video"
        arial-label="Close Video"
        tabIndex={0}
      >
        {/* <IconSvg size={IconSvgSizes.MD} svgNodeStr={closeIcon} /> */}
      </button>
    );
  }

  private getControls() {
    const isCinema = this.props.options && this.props.options.cinema;
    const customClass =
      "Player__controller" +
      (this.state.fullscreen ? ' ' + "Player__fullscreen" : '') +
      (isCinema ? ' ' + "Player__cinema" : '');
    return (
      <Controller
        ref={this.controllerRef}
        // @ts-ignore: TODO
        data={{
          caption: this.state.showCaption,
          chapteredVideoData: this.props.data.chapteredVideo,
          currentTime: this.state.ctrlCurrentTime,
          fullScreen: this.state.fullscreen,
          playing: this.state.playing,
          totalTime: this.state.totalTime,
          transcript: false,
        }}
        options={{
          className: customClass,
          enlarge: !isCinema,
          showCaption: this.props.options && this.props.options.showCaption,
          showFullScreen: true,
          showTranscript: !isCinema,
          containerWidth: this.props.options.containerWidth,
          modal: this.props.options?.modal
        }}
        events={{
          captionClick: this.captionClick,
          fullScreenClick: this.fullScreenClick,
          handleMute: this.handleVolume,
          handlePlayPause: this.handlePlayPause,
          handleSeekVideo: this.handleSeekVideo,
          transcriptClick: this.transcriptClick,
        }}
      />
    );
  }

  private getVideoComponent() {
    const isModal = this.props.options && this.props.options.modal;
    const isCinema = this.props.options && this.props.options.cinema;
    const customClass =
      "Player__video bg-black" + this.props?.options?.roundedCornersClassName +
      (this.state.fullscreen ? ' ' + "Player__fullscreen" : '') +
      (isModal ? ' ' + "Player__modal" : '') +
      (isCinema ? ' ' + "Player__cinema" : '') + (this.props?.options?.unconstrained === true && !isModal ? '': ' Player__player__video');
    const options: VideoComponentOptions = {
      autoPlay: (this.props.options && this.props.options.autoplay)!,
      cinema: isCinema,
      className: customClass,
      linkUrl: this.props.data.linkUrl,
      loop: (this.props.options && this.props.options.loop)!,
      muted: this.state.mute,
      playing: this.state.playing,
      volume: this.state.volume,
      safariAutoPlay: ((this.props.options && this.props.options.safariAutoPlay) || (this.props.options && this.props.options.playerView)),
      roundedCornersClassName: this.props?.options?.roundedCornersClassName,
      containerWidth: this.props.options.containerWidth
    };
    return (
      <VideoComponent
        ref={this.videoRef}
        data={{
          chapteredVideoData: this.props.data.chapteredVideo,
          controlsOpacity: this.controlsOpacity,
           currentTime: this.state.currentTime,
          id: this.props.data.id,
          poster: this.props.data.poster!,
           recommendedVideosCTAViewData:
            this.props.data.recommendedVideosCTAViewData,
           showCaption: this.state.showCaption,
          sources: this.props.data.sources,
          textTracks: this.props.data.textTracks,
          title: this.props?.data?.title 
        }} 

        options={options}
        events={{
          handleOnTimeUpdate: this.updateCurrentTime,
          handleOnloadedmetadata: this.getDuration,
          handleOverlayPlayPause: this.updatePlaying,
          handleOverlayRecommendedVideoItem: this.playRecommendedVideoItem,
          handleOverlayReplay: this.updatePlaying,
        }}
      />
    );
  }

  private getTranscript() {
    const panel = (
      <TranscriptComponent
        data={{
          captionData: { captions: this.props.data.textTracks! },
          chapteredVideoData: this.props.data.chapteredVideo,
          currentTime: this.state.ctrlCurrentTime,
          date: this.props.data.date,
          duration: this.props.data.duration,
          printTitle: this.props.data.printTitle,
        }}
        events={{ updateCurrentTime: this.handleTranscriptUpdateTime }}
        options={{ className: "Player__panel", containerWidth: this.props.options.containerWidth }}
      />
    );
    if (
      this.state.showTranscript &&
      this.props.data.chapteredVideo &&
      this.props.data.chapteredVideo.length <= 0
    ) {
      return panel;
    } else if (
      this.props.data &&
      this.props.data.chapteredVideo &&
      this.props.data.chapteredVideo.length > 0 &&
      !this.props?.options?.cinema &&
      !this.state.showTranscript
    ) {
      return panel;
    } else {
      return null;
    }
  }

  private handleTranscriptUpdateTime(value: number) {
    this.setState({ currentTime: value });
  }
  get small(): boolean {
    if (!window) {
      return false;
    } else if (window.innerWidth < 500) {
      return true;
    } else {
      return false;
    }
  }
}